	<div class="flex justify-content-center p-0">
		<div class="p-col-12 p-md-6 p-lg-3 px-3 py-0">
			<div class="flex justify-content-center p-0">
				<div class="p-col-12 p-md-6 p-lg-3 p-0">
					<h3 >{{ 'button.partsMovement' | translate }}</h3>
				</div>
			</div>

			<div class="pb-0">
				<label>{{ 'h5.labelCode' | translate }}</label>
				<input  type="text" minlength="1" maxlength="21" min="1" pInputText inputmode="text" tabindex="-1"
						[ngClass]="{focusField: inputFields[0].focus}" [disabled]="pendingMovement"
						[(ngModel)]="inputFields[0].value" [id]="inputFields[0].id"
						(keydown.enter)="checkLabelPart()" (ngModelChange)="setInputToInvalid('label_part')"
						(focus)="focusInputFields('label_part')"
						(blur)="blurInputFields('label_part')">
			</div>

			<div class="card pl-3 pb-2 pt-0"*ngIf="showLabelText && inputFields[0].valid === true">
				<div class="p-1 z-0">
					<h5>{{ 'h5.part' | translate }}: <span class="text-sm opacity-60 ">{{ locationFrom.bkGspnPrefixC + '/' + locationFrom.bkGspnBaseC + '/' + locationFrom.bkGspnSuffixC }}</span></h5>
					<h5>{{ 'h5.staging' | translate }}: <span class="text-sm opacity-60">{{ locationFrom.bkLocationC }}</span></h5>
					<h5>{{ 'h5.quantity' | translate }}: <span class="text-sm opacity-60">{{ locationFrom.freeStock }}</span></h5>
				</div>
			</div>

			<div  class="p-col-12 p-0" *ngIf="showPartInputs && inputFields[0].valid === true">
				<div>
					<label>{{ 'h5.locationFrom' | translate }}:</label>
					<input  type="text" minlenght="1" maxlength="16" min="1"
							[ngClass]="{focusField: inputFields[1].focus}" pInputText tabindex="-1"
							inputmode="text" [(ngModel)]="inputFields[1].value"
							(ngModelChange)="setInputToInvalid('location_from')"
							(keydown.enter)="checkLocationFrom()" (keydown.tab)="checkLocationFrom()"
							[id]="inputFields[1].id" [disabled]="pendingMovement"
							(focus)="focusInputFields('location_from')"
							(blur)="blurInputFields('location_from')">
				</div>
				<div>
					<label>{{ 'h5.quantity' | translate }}:</label>
					<input  type="number" inputmode="numeric" min="1" maxlength="16" pInputText tabindex="-1"
							[(ngModel)]="inputFields[2].value" [ngClass]="{focusField: inputFields[2].focus}"
							[id]="inputFields[2].id" (ngModelChange)="setInputToInvalid('quantity_from')"
							(focus)="focusInputFields('quantity_from')" (keydown.enter)="checkQuantityFrom()"
							onkeydown="if(event.key==='.'){event.preventDefault();}"
							(onkeydown)="numberOnly($event)" [disabled]="pendingMovement">
					<h5 class="info-qty text-right" *ngIf="typeSearch === 'label' && locationFrom && inputFields[1].valid === true">{{ 'h5.quantityAtLocation' | translate }}: {{ locationFrom.freeStock}}</h5>
					<h5 class="info-qty text-right" *ngIf="typeSearch === 'part' && locationFrom && inputFields[1].valid === true">{{ 'h5.quantityAtLocation' | translate }}: {{ locationFrom.freeStock}}</h5>
				</div>
			</div>

			<div class="p-col-12 p-0" *ngIf="showLabelText || showPartInputs && inputFields[0].valid === true">
				<div>
					<label>{{ 'h5.locationTo' | translate }}:</label>
					<input type="text" minlength="1" maxlength="16" inputmode="text" tabindex="-1"
						   [ngClass]="{focusField: inputFields[3].focus}" pInputText
						   [(ngModel)]="inputFields[3].value" [id]="inputFields[3].id"
						   (keydown.enter)="checkLocationTo()" (keydown.tab)="checkLocationTo()" (ngModelChange)="setInputToInvalid('location_to')"
						   (focus)="getSuggestionAndFocus()" (blur)="blurInputFields('location_to')">
				</div>
				<div>
					<label>{{ 'h5.quantity' | translate }}:</label>
					<input  type="number"
							inputmode="numeric" [ngClass]="{focusField: inputFields[4].focus}" pInputText tabindex="-1"
							[(ngModel)]="inputFields[4].value" [id]="inputFields[4].id"
							(keydown.enter)="checkQuantityTo()" (ngModelChange)="setInputToInvalid('quantity_to')"
							(focus)="focusInputFields('quantity_to')" (blur)="blurInputFields('quantity_to')"
							onkeydown="if(event.key==='.'){event.preventDefault();}"
							(onkeydown)="numberOnly($event)">
				</div>
				<div class="button_container ">
				</div>
				<div class="flex justify-content-center p-0">
					<div class="p-col-12 p-md-6 p-lg-3 p-0">
						<button pButton (click)="postMoveLocation()" label="OK" class="submit" [disabled]="checkDisableButton()"></button>
					</div>
				</div>
			</div>
		</div>
	</div>


	<input-generic
		[inputFields]="inputFields" tabindex="-1"
		(eventEmitter)="executeAction($event)">
	</input-generic>

	<stock-pick *ngIf="showStockPickModal"
		(onEmitStockTypeUidK)="chosenValueStockTypeUidK($event)">
	</stock-pick>

	<alert-custom *ngIf="showAlert"
		(onCloseModal)="hideErrorModal($event)"
		[msg]="errorMessage"
		[elId]="errorFocus"
		[title]="errorTitle">
	</alert-custom>
